// ⚠️ LEAF MODULE: absolutely no imports here to break any cycles
// This module exists solely to provide safe project property access
// without participating in any import dependency chains

/**
 * Safely extract project title/name from any project object shape
 * Handles various project object structures across the app
 */
export const safeProjectTitle = (p: any): string => {
  return p?.bookStructure?.currentProjectName ?? p?.title ?? 'Untitled Project';
};

/**
 * Safely extract project name (alias for title)
 */
export const safeProjectName = (p: any): string => {
  return p?.bookStructure?.currentProjectName ?? p?.title ?? 'Untitled Project';
};

/**
 * Safely extract project type/book type
 */
export const safeProjectType = (p: any): string => {
  return p?.bookType?.replace('_', ' ') ?? 'Story';
};

/**
 * Safely extract project word count
 */
export const safeProjectWordCount = (p: any): number => {
  return p?.targetWordCount ?? 0;
};

/**
 * Safely extract project ID
 */
export const safeProjectId = (p: any): string | null => {
  return p?.uuid ?? p?.id ?? null;
};

/**
 * Normalize any raw project object to ensure consistent shape
 * This prevents crashes from missing nested properties
 */
export const normalizeProjectShape = (raw: any) => {
  if (!raw) return null;

  const safeTitle = safeProjectTitle(raw);

  return {
    ...raw,
    title: raw.title ?? safeTitle,
    bookStructure: {
      ...(raw.bookStructure ?? {}),
      currentProjectName: raw.bookStructure?.currentProjectName ?? safeTitle,
    },
    meta: {
      ...(raw.meta ?? {}),
      updatedAt: raw.meta?.updatedAt ?? new Date().toISOString(),
    },
  };
};